(() => {
  if (window.cityCollectionVtoReady) return;
  window.cityCollectionVtoReady = true;

  let vtoScriptPromise = null;

  const readPayload = (button) => {
    const card = button.closest('[data-city-collection-vto-card]');
    try {
      return JSON.parse(card?.querySelector('[data-city-collection-vto-payload]')?.textContent || '');
    } catch (_) {
      return null;
    }
  };

  const displayedVariantId = (button, payload) => {
    const card = button.closest('.card-wrapper');
    const activeImage = card?.querySelector('.card-sunglasses-hover-image.is-active[data-city-vto-variant-id]');
    const baseImage = card?.querySelector('.card__media .media > img[data-city-vto-variant-id]');
    const displayedId = String(activeImage?.dataset.cityVtoVariantId || baseImage?.dataset.cityVtoVariantId || '');
    if (payload?.profiles?.[displayedId]) return displayedId;
    const fallbackId = String(payload?.fallbackVariantId || payload?.initialVariantId || '');
    return payload?.profiles?.[fallbackId] ? fallbackId : '';
  };

  const syncCardTrigger = (card) => {
    const button = card?.querySelector('[data-city-collection-vto-trigger]');
    if (!button) return;
    const payload = readPayload(button);
    button.hidden = !displayedVariantId(button, payload);
  };

  const syncAllTriggers = (root = document) => {
    root.querySelectorAll?.('.card-wrapper').forEach(syncCardTrigger);
  };

  const observeGrid = () => {
    const grid = document.getElementById('ProductGridContainer');
    if (!grid) return;
    syncAllTriggers(grid);
    new MutationObserver((records) => {
      const cards = new Set();
      records.forEach((record) => {
        const card = record.target.closest?.('.card-wrapper');
        if (card) cards.add(card);
      });
      if (records.some((record) => record.type === 'childList')) syncAllTriggers(grid);
      else cards.forEach(syncCardTrigger);
    }).observe(grid, { subtree: true, childList: true, attributes: true, attributeFilter: ['class'] });
  };

  const loadVto = (shell) => {
    if (customElements.get('city-virtual-try-on')) return Promise.resolve();
    if (vtoScriptPromise) return vtoScriptPromise;

    vtoScriptPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = shell.dataset.vtoScriptUrl;
      script.async = true;
      script.addEventListener('load', () => customElements.whenDefined('city-virtual-try-on').then(resolve), { once: true });
      script.addEventListener('error', reject, { once: true });
      document.head.append(script);
    }).catch((error) => {
      vtoScriptPromise = null;
      throw error;
    });

    return vtoScriptPromise;
  };

  const triggerFromEvent = (event) => {
    const direct = event.target.closest?.('[data-city-collection-vto-trigger]');
    if (direct) return direct;
    if (!Number.isFinite(event.clientX) || !Number.isFinite(event.clientY)) return null;
    const candidate = event.target.closest?.('.card-wrapper')?.querySelector('[data-city-collection-vto-trigger]');
    if (!candidate) return null;
    const rect = candidate.getBoundingClientRect();
    return event.clientX >= rect.left && event.clientX <= rect.right && event.clientY >= rect.top && event.clientY <= rect.bottom
      ? candidate
      : null;
  };

  document.addEventListener('click', async (event) => {
    const button = triggerFromEvent(event);
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();
    if (button.disabled) return;

    const payload = readPayload(button);
    const shell = document.querySelector('city-virtual-try-on[data-collection-vto="true"]');
    const variantId = displayedVariantId(button, payload);
    if (!payload || !shell || !variantId) {
      syncCardTrigger(button.closest('.card-wrapper'));
      return;
    }

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    try {
      await loadVto(shell);
      shell.openCollection(payload, button, variantId);
    } catch (_) {
      button.dataset.vtoLoadError = 'true';
    } finally {
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observeGrid, { once: true });
  else observeGrid();
})();
